import { Thread } from "./components/thread";
import { ThreadList } from "./components/thread-list";
import { ChatNavbar } from "./components/chat-navbar";
import { AgentProvider } from "./context/AgentContext";
import "../chat.css";
import { MyRuntimeProvider } from "./lib/remote-runtime-provider";
import { useParams } from "react-router-dom";

export const ChatApp = () => {
  const { threadId } = useParams();

  return (
    <AgentProvider>
      <MyRuntimeProvider initialThreadId={threadId}>
        <div className="chat-container flex h-dvh relative">
          <div className="chat-sidebar flex flex-col">
            <div className="flex items-center border-b border-border bg-background px-4 py-4">
              <div className="flex items-center gap-2">
                <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-primary">
                  <span className="text-sm font-bold text-primary-foreground">
                    AI
                  </span>
                </div>
                <span className="font-semibold text-foreground">AgentIQ</span>
              </div>
            </div>
            <ThreadList />
          </div>
          <div className="chat-main flex flex-1 flex-col">
            <ChatNavbar />
            <Thread />
          </div>
        </div>
      </MyRuntimeProvider>
    </AgentProvider>
  );
};
